export default __webpack_public_path__ + "static/media/project2update.207b3e23.png";